import {
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  useDisclosure,
} from '@chakra-ui/react';
import { Table } from '@tanstack/react-table';
import React from 'react';

import { UpdateFacilityNameModal } from './UpdateFacilityNameModal';
import {
  CsvXlsxDownloadSelect,
  getTanstackVisibleDataForDownload,
} from 'packages/common-frontend/components/CsvXlsxDownloadSelect';
import { FacilitiesTableRowData } from '~/core/routes/credit-facilities/facilitiesTableOptions';
import { colors } from '~/packages/common-frontend/colors';
import { IconButtonV2 } from '~/packages/common-frontend/components/IconButton';
import { Icon } from '~/packages/common-frontend/components/icons';

// Exports
export const FacilitiesTableMenu = ({
  table,
}: {
  table: Table<FacilitiesTableRowData>;
}) => {
  const menuControls = useDisclosure();
  const updateFacilityNameControls = useDisclosure();

  const csvDownload = getTanstackVisibleDataForDownload({
    tableInstance: table,
  });

  return (
    <>
      <Menu {...menuControls}>
        <MenuButton
          as={IconButtonV2}
          variant="secondary-muted"
          colorScheme="gray"
          isActive={menuControls.isOpen}
          aria-label="Facility options"
          icon={<Icon icon="ellipsis-vertical" />}
          tooltipEnabled={false}
        />
        <MenuList zIndex="dropdown">
          <MenuItem
            onClick={updateFacilityNameControls.onOpen}
            color={colors.gray[800]}
          >
            <Icon icon="edit" style={{ marginRight: '0.75rem' }} />
            Edit Facility Names
          </MenuItem>
          <CsvXlsxDownloadSelect
            returnMenuItemsOnly
            dataRows={csvDownload.dataRows}
            headers={csvDownload.headers}
            filenamePrefix="facilities"
          />
        </MenuList>
      </Menu>
      {updateFacilityNameControls.isOpen && (
        <UpdateFacilityNameModal modalControls={updateFacilityNameControls} />
      )}
    </>
  );
};
